export default "__VITE_ASSET__BcT6GuJm__"